import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, message , Modal ,Checkbox ,Popconfirm ,Icon } from 'antd';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import ExportUtil from '../../../common/ExportUtil';
import UploadFile from '../../common/UploadFile';
import format from '../../shared/format';
import cellRenderEnhancer, { beforeChangeEnhancer } from '../../shared/cellRenderEnhancer';
import Filter from './Filter';
import TableC from '../../basicElement/TableC';
import ProjectSideNav from '../../projectContract/SideNav';
import SideNav from '../SideNav';
import fp from '../../../utils/fp';
import cf from '../../../utils/cf';
import { getValueByPath } from 'element-ui/lib/utils/util';
import { saveParams } from '../../../actions/noticeActions';
import Config from './Config';
import Operation from './Operation';
import Update from './Update';
import ConfigColumn from './ConfigColumn';

const CheckboxGroup = Checkbox.Group;
class ReturnedMoney extends Component {
    constructor(props) {
        super(props);
        const { params:{ jdecode, remark } } = props;
        const searchParams = {};
        if (jdecode && remark) {
            searchParams.jdecode = jdecode;
            searchParams.remark = remark;
        }
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            curParams: {...searchParams},
            searchParams: {...searchParams},
            pagination: {
                pageSize: 10,
                current: 1,
            },
            businessList: [],
            contractTypeList: [],
            belongingToUnit: [],
            tableHeader: [],
            visible:false,
            visibleUpload:false,
            uploadMes:{},
            templateType1:false,//预收款退款模板
            templateType2:false//外币收款汇率差异模板
        }
    }

    componentDidMount() {
        // this.loadData();
        this.queryWithLevelByParams();
        this.loadTypeConfigureList();
        this.queryBelongingToUnit();
        this.getHeader();
    }

    componentWillUnmount() {
        const { saveParams } = this.props;
        saveParams({ remark: undefined, jdecode: undefined });
    }

    queryBelongingToUnit = () => {
        dictCache.getDict('UNIT_BELONGING', cb => {
            Fetch.post(API_URL.contract.queryUnitOfBelongingList, { limit: 999 })
                .then(cb)
                .catch(error => {
                    console.error(error);
                });
        }, res => {
            this.setState({ belongingToUnit: res.datas || [] });
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            Fetch.post(API_URL.common.queryWithLevelByParams, { typeName: 'LINE_OF_BUSINESS' })
                .then(cb)
                .catch(err => {
                    console.error(err);
                });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            Fetch.post(API_URL.common.typeConfigureList)
                .then(cb)
                .catch(error => {
                    console.error(error);
                });
        }, res => {
            this.setState({ contractTypeList: res.contractTypeList || [] });
        });
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(curParams);
        Fetch.post(API_URL.contract.queryContractBackRecordList, {
            offset: current,
            limit: 10,
            ...sortParams,
            ...params,
            curInvId: '',
        }).then(res => {
            const { datas, totalCount } = res;
            pagination.total = Math.ceil(totalCount / 10) * datas.length;
            pagination.pageSize = datas.length;
            this.setState({
                loading: false,
                data: datas,
                pagination,
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {...searchParams}
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const params = this.splitParams(curParams);
        Fetch.post(API_URL.contract.exportContractBackRecordList, { ...sortParams, ...params })
        .then(res => {
            message.success(res.success);
        }).catch(error => {
            console.error(error);
        });
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    handleStringLinefeed = (text) => {
        const arr = (text || '').split(',');
        const result = arr.map((item, index) => {
            return <span key={index}>{item}{index < arr.length - 1 ? ',' : ''}<br /></span>;
        });
        return result;
    }

    configColumn = () => {
        const { tableHeader } = this.state;
        this.configColumnRef.show(tableHeader);
    }

    getHeader = () => {
        Fetch.post(API_URL.common.queryUserCustomDisplayByUserId, {
            type: 'CONTRACT_BACK_RECORD'
        }).then(res => {
            this.setState({ tableHeader: res.CONTRACT_BACK_RECORD }, () => {
                this.loadData();
            });
        })
    }

    getColumns = () => {
        const columns = [];
        const { tableHeader } = this.state;
        columns.push({
            title:<div className="config_clm_oper">
                <span>JDE主项目号</span>
                <Icon 
                    onClick={() => this.configColumn()} 
                    type="setting" 
                    style={{ 
                        float: "right", 
                        fontSize: "18px", 
                        marginRight: "10px" 
                    }}
                />
            </div>,
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            fixed: 'left',
            width: 140,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            width: 160,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            fixed: 'left',
            width: 120,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            fixed: 'left',
            width: 120,
        });
        tableHeader.forEach(el => {
            if (el.isDefault == '0' && el.isShow == '1') {
                const params = {};
                switch (el.dataIndex) {
                    case 'invoiceDate1':
                    case 'invoiceDate2':
                        params.title = el.title;
                        params.dataIndex = 'invoiceDate';
                        params.key = el.dataIndex;
                        params.width = 120;
                        break;
                    case 'overduePeriodFlag':
                        params.title = el.title;
                        params.dataIndex = 'overduePeriodFlagStr';
                        params.key = el.dataIndex;
                        params.width = 120;
                        break;
                    default:
                        params.title = el.title;
                        params.dataIndex = el.dataIndex;
                        params.key = el.dataIndex;
                        params.width = 120;
                        break;
                }
                columns.push(params);
            }
        })
        columns.push({
            title:'操作',
            dataIndex: 'operation',
            key: 'operation',
            width: 100,
            render: (text, row) => {
                const { jdeMainCode, contractBackRecordId, dataType, actualPaymentStatus, currentPm, currencyCode, receivingAmount } = row;
                const { curRole, curEmployeeCode } = sessionStorage;
                const canDelete = curRole == 'FIN' && (dataType == 'ADVANCE_IMPORT' || dataType == 'FOREIGN_CURRENCY_IMPORT');
                const isTotalRow = jdeMainCode === '服务费合计' || jdeMainCode === 'PT费合计' || jdeMainCode === 'UC合计' || jdeMainCode === '总计';
                const operationCorrespondRoles = new Map([
                    ['update', {
                        name: '修改',
                        display: (currencyCode !== 'CNY' || receivingAmount < 0 ) && !isTotalRow,
                        editable: true,
                        event: () => this.updateRef.show(row),
                        roles: ['*'],
                    }],
                    ['delete', {
                        name: '删除',
                        display: canDelete,
                        editable: true,
                        event: () => this.remove(contractBackRecordId),
                        roles: ['*'],
                    }],
                    ['config', {
                        name: '配置合同约定账期',
                        display: actualPaymentStatus !== 'PENDING_APPROVAL' && currentPm,
                        editable: true,
                        event:  () => this.showConfig(row, 'config'),
                        roles: ['*'],
                    }],
                    ['audit', {
                        name: '审核合同约定账期',
                        display: actualPaymentStatus == 'PENDING_APPROVAL',
                        editable: true,
                        event:  () => this.showConfig(row, 'audit'),
                        roles: ['CSAL','CSA'],
                    }],
                    ['operation', {
                        name: '操作日志',
                        display: contractBackRecordId,
                        editable: true,
                        event:  () => this.showOperation(row),
                        roles: ['*'],
                    }],
                ]);
                return (
                    <span>
                        {   fp.compose(
                                fp.curry(cf.operationAuthByRole)(index => <span key={index} className="ant-divider" />),
                                fp.filter(i => !!i),
                                // 获取角色对应操作
                                fp.curry(cf.authDomList)(operationCorrespondRoles)
                            )(curRole)
                        }
                    </span>
                );
            }
        })
        return columns;
    }

    // getColumns = () => {
    //     const columns = [{
    //         title:<div className="config_clm_oper">
    //             <span>JDE主项目号</span>
    //             <Icon 
    //                 onClick={() => this.configColumn()} 
    //                 type="setting" 
    //                 style={{ 
    //                     float: "right", 
    //                     fontSize: "18px", 
    //                     marginRight: "10px" 
    //                 }}
    //             />
    //         </div>,
    //         dataIndex: 'jdeMainCode',
    //         key: 'jdeMainCode',
    //         fixed: 'left',
    //         width: 140,
    //     }, {
    //         title: '项目简称',
    //         dataIndex: 'investigationName',
    //         key: 'investigationName',
    //         fixed: 'left',
    //         width: 160,
    //     }, {
    //         title: '项目编号',
    //         dataIndex: 'investigationCode',
    //         key: 'investigationCode',
    //         fixed: 'left',
    //         width: 120,
    //     }, {
    //         title: '项目领域',
    //         dataIndex: 'investigationAreaName',
    //         key: 'investigationAreaName',
    //         fixed: 'left',
    //         width: 120,
    //     }, {
    //         title: 'PM工号',
    //         dataIndex: 'pmCodes',
    //         key: 'pmCodes',
    //         width: 80,
    //         render: this.handleStringLinefeed,
    //     }, {
    //         title: 'PM姓名',
    //         dataIndex: 'pmNames',
    //         key: 'pmNames',
    //         width: 80,
    //         render: this.handleStringLinefeed,
    //     }, {
    //         title: 'BD工号',
    //         dataIndex: 'bdCodes',
    //         key: 'bdCodes',
    //         width: 80,
    //         render: this.handleStringLinefeed,
    //     }, {
    //         title: 'BD姓名',
    //         dataIndex: 'bdNames',
    //         key: 'bdNames',
    //         width: 80,
    //         render: this.handleStringLinefeed,
    //     }, {
    //         title: 'JDE项目号',
    //         dataIndex: 'jdecode',
    //         key: 'jdecode',
    //         width: 100,
    //     }, {
    //         title: '业务线',
    //         dataIndex: 'lineOfBusinessString',
    //         key: 'lineOfBusinessString',
    //         width: 80,
    //     }, {
    //         title: '执行业务线二级分类',
    //         dataIndex: 'secondLineNames',
    //         key: 'secondLineNames',
    //         width: 100,
    //     }, {
    //         title: '计收入确认方式',
    //         dataIndex: 'contractTypeValue',
    //         key: 'contractTypeValue',
    //         width: 80,
    //         render: cellRenderEnhancer({
    //             renderContent: beforeChangeEnhancer((record) => record['oldContractTypeValue'])
    //        })(),
    //     }, {
    //         title: '关联主键(文件编号)',
    //         dataIndex: 'documentNumber',
    //         key: 'documentNumber',
    //         width: 80,
    //     }, {
    //         title: '关联主键(文件类型)',
    //         dataIndex: 'documentType',
    //         key: 'documentType',
    //         width: 80,
    //     }, {
    //         title: '关联主键(文件公司)',
    //         dataIndex: 'documentCompany',
    //         key: 'documentCompany',
    //         width: 80,
    //     }, {
    //         title: '关联主键(支付行号)',
    //         dataIndex: 'payItem',
    //         key: 'payItem',
    //         width: 80,
    //     }, {
    //         title: '发票号',
    //         dataIndex: 'remark',
    //         key: 'remark',
    //         width: 120,
    //     }, {
    //         title: '客户代码',
    //         dataIndex: 'addressNumber',
    //         key: 'addressNumber',
    //         width: 80,
    //     }, {
    //         title: '客户名称',
    //         dataIndex: 'alphaname',
    //         key: 'alphaname',
    //         width: 120,
    //     }, {
    //         title: '收入归属单位',
    //         dataIndex: 'unitOfBelongingName',
    //         key: 'unitOfBelongingName',
    //         width: 100,
    //     }, {
    //         title: '领域leader',
    //         dataIndex: 'talName',
    //         key: 'talName',
    //         width: 120,
    //     }, {
    //         title: '发票描述(包含Milstone和PT非PT)',
    //         dataIndex: 'reference',
    //         key: 'reference',
    //         width: 120,
    //     }, {
    //         title: '内部红冲原因',
    //         dataIndex: 'internalRedCreditReasonShow',
    //         key: 'internalRedCreditReasonShow',
    //         width: 100,
    //     }, {
    //         title: '总账冲销',
    //         dataIndex: 'gloffSet',
    //         key: 'gloffSet',
    //         width: 80,
    //     }, {
    //         title: '预收未开票',
    //         dataIndex: 'isAdvanceCollectedNotInvoiced',
    //         key: 'isAdvanceCollectedNotInvoiced',
    //         width: 80,
    //     }, {
    //         title: '本位币种',
    //         dataIndex: 'baseCurrency',
    //         key: 'baseCurrency',
    //         width: 90,
    //     }, {
    //         title: '结算币种',
    //         dataIndex: 'currencyCode',
    //         key: 'currencyCode',
    //         width: 80,
    //     }, {
    //         title: '汇率',
    //         dataIndex: 'exchangeRate',
    //         key: 'exchangeRate',
    //         width: 80,
    //     }, {
    //         title: '发票日期',
    //         dataIndex: 'invoiceDate',
    //         key: 'invoiceDate',
    //         width: 80,
    //     }, {
    //         title: '发票金额（不含税）/人民币',
    //         dataIndex: 'taxableAmount',
    //         key: 'taxableAmount',
    //         width: 90,
    //         render: text => format('money', text),
    //     }, {
    //         title: '发票金额(税)',
    //         dataIndex: 'tax',
    //         key: 'tax',
    //         width: 110,
    //         render: text => format('money', text),
    //     }, {
    //         title: '发票金额(含税总额)总金额',
    //         dataIndex: 'grossAmount',
    //         key: 'grossAmount',
    //         width: 100,
    //         render: text => format('money', text),
    //     }, {
    //         title: '未结金额',
    //         dataIndex: 'openAmount',
    //         key: 'openAmount',
    //         width: 100,
    //         render: text => format('money', text),
    //     }, {
    //         title: '外币未结金额',
    //         dataIndex: 'foreignOpenAmount',
    //         key: 'foreignOpenAmount',
    //         width: 100,
    //         render: text => format('money', text),
    //     }, {
    //         title: '外币应税额',
    //         dataIndex: 'foreignTaxableAmount',
    //         key: 'foreignTaxableAmount',
    //         width: 100,
    //         render: text => format('money', text),
    //     }, {
    //         title: '外币税额--外币发票金额(税)',
    //         dataIndex: 'foreignTaxAmount',
    //         key: 'foreignTaxAmount',
    //         width: 100,
    //         render: text => format('money', text),
    //     }, {
    //         title: '账期',
    //         dataIndex: 'paymentTerms',
    //         key: 'paymentTerms',
    //         width: 80,
    //     }, {
    //         title: '合同约定账期',
    //         dataIndex: 'actualPaymentTerms',
    //         key: 'actualPaymentTerms',
    //         width: 80,
    //         render: ( text, record ) => {
    //             const { actualPaymentStatus, contractAgreedPaymentTerms } = record;
    //             return actualPaymentStatus == 'AGREE_APPROVAL' ? text : contractAgreedPaymentTerms
    //         }
    //     }, {
    //         title: '开票时间',
    //         dataIndex: 'invoiceDates',
    //         key: 'invoiceDates',
    //         width: 80,
    //         render: (text, record) => {
    //             const { invoiceDate } = record;
    //             return invoiceDate;
    //         }
    //     }, {
    //         title: '到期日期',
    //         dataIndex: 'dueDate',
    //         key: 'dueDate',
    //         width: 80,
    //     }, {
    //         title: '实际到期日期',
    //         dataIndex: 'actualExpirationDate',
    //         key: 'actualExpirationDate',
    //         width: 80,
    //     }, {
    //         title: '账龄',
    //         dataIndex: 'aging',
    //         key: 'aging',
    //         width: 80,
    //     }, {
    //         title: '确认收款金额(含税总额)/原币',
    //         dataIndex: 'receivingAmountInitial',
    //         key: 'receivingAmountInitial',
    //         width: 100,
    //         render: text => format('money', text),
    //     }, {
    //         title: '确认收款金额(含税总额)/人民币',
    //         dataIndex: 'receivingAmount',
    //         key: 'receivingAmount',
    //         width: 100,
    //         render: text => format('money', text),
    //     }, {
    //         title: '确认收款金额（不含税）/人民币',
    //         dataIndex: 'receivingAmountNoTaxCny',
    //         key: 'receivingAmountNoTaxCny',
    //         width: 100,
    //         render: text => format('money', text),
    //     }, {
    //         title: '收款日期',
    //         dataIndex: 'DateInvoiceClosed',
    //         key: 'DateInvoiceClosed',
    //         width: 80,
    //     }, {
    //         title: '收款号',
    //         dataIndex: 'receiptNumber',
    //         key: 'receiptNumber',
    //         width: 100,
    //     }, {
    //         title: '最新更新时间',
    //         dataIndex: 'lastUpdateTime',
    //         key: 'lastUpdateTime',
    //         width: 90,
    //     }, {
    //         title: '发票核销日期',
    //         dataIndex: 'CheckItemDate',
    //         key: 'CheckItemDate',
    //         width: 90,
    //     }, {
    //         title: '过账编辑',
    //         dataIndex: 'postingEdit',
    //         key: 'postingEdit',
    //         width: 80,
    //     }, {
    //         title: '类别码13',
    //         dataIndex: 'categoryCode13',
    //         key: 'categoryCode13',
    //         width: 90,
    //         render: (text, record) => {
    //             return text ? <span style={{ color: record.categoryCodeStatus == 1 && 'red' }}>{text}</span> : '';
    //         }
    //     }, {
    //         title: '公司代号',
    //         dataIndex: 'company',
    //         key: 'company',
    //         width: 80,
    //     }, {
    //         title: '总帐日期',
    //         dataIndex: 'gldate',
    //         key: 'gldate',
    //         width: 80,
    //     }, {
    //         title: '支付状态',
    //         dataIndex: 'payStatus',
    //         key: 'payStatus',
    //         width: 80,
    //     }, {
    //         title: '请款单号',
    //         dataIndex: 'invoiceNumber',
    //         key: 'invoiceNumber',
    //         width: 100,
    //     }, {
    //         title: '费用类型',
    //         dataIndex: 'expenseType',
    //         key: 'expenseType',
    //         width: 80,
    //     },{
    //         title:'操作',
    //         dataIndex: 'operation',
    //         key: 'operation',
    //         width: 100,
    //         render: (text, row) => {
    //             const { jdeMainCode, contractBackRecordId, dataType, actualPaymentStatus, currentPm, currencyCode, receivingAmount } = row;
    //             const { curRole, curEmployeeCode } = sessionStorage;
    //             const canDelete = curRole == 'FIN' && (dataType == 'ADVANCE_IMPORT' || dataType == 'FOREIGN_CURRENCY_IMPORT');
    //             const isTotalRow = jdeMainCode === '服务费合计' || jdeMainCode === 'PT费合计' || jdeMainCode === 'UC合计' || jdeMainCode === '总计';
    //             const operationCorrespondRoles = new Map([
    //                 ['update', {
    //                     name: '修改',
    //                     display: (currencyCode !== 'CNY' || receivingAmount < 0 ) && !isTotalRow,
    //                     editable: true,
    //                     event: () => this.updateRef.show(row),
    //                     roles: ['*'],
    //                 }],
    //                 ['delete', {
    //                     name: '删除',
    //                     display: canDelete,
    //                     editable: true,
    //                     event: () => this.remove(contractBackRecordId),
    //                     roles: ['*'],
    //                 }],
    //                 ['config', {
    //                     name: '配置合同约定账期',
    //                     display: actualPaymentStatus !== 'PENDING_APPROVAL' && currentPm,
    //                     editable: true,
    //                     event:  () => this.showConfig(row, 'config'),
    //                     roles: ['*'],
    //                 }],
    //                 ['audit', {
    //                     name: '审核合同约定账期',
    //                     display: actualPaymentStatus == 'PENDING_APPROVAL',
    //                     editable: true,
    //                     event:  () => this.showConfig(row, 'audit'),
    //                     roles: ['CSAL','CSA'],
    //                 }],
    //                 ['operation', {
    //                     name: '操作日志',
    //                     display: contractBackRecordId,
    //                     editable: true,
    //                     event:  () => this.showOperation(row),
    //                     roles: ['*'],
    //                 }],
    //             ]);
    //             return (
    //                 <span>
    //                     {   fp.compose(
    //                             fp.curry(cf.operationAuthByRole)(index => <span key={index} className="ant-divider" />),
    //                             fp.filter(i => !!i),
    //                             // 获取角色对应操作
    //                             fp.curry(cf.authDomList)(operationCorrespondRoles)
    //                         )(curRole)
    //                     }
    //                 </span>
    //             );
    //         }
    //     }];
    //     return columns;
    // }

    showConfig = (record, type) => {
        this.configRef.show(record, type);
    }
    
    showOperation = (record) => {
        this.operationRef.show(record);
    }

    remove = (contractBackRecordId) => {
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.delContractBackRecord, {
            contractBackRecordId,
        }).then(res => {
            const { success } = res;
            message.success(success);
            this.setState({ loading: false }, () => {
                this.loadData();
            });
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    downloadTemplate =()=>{
        this.setState({visible:true})
    }

    getDownloadTemplate = () => {
        const {visible,templateType1,templateType2 } = this.state;
        return (
            <Modal
                title='下载模板'
                visible={visible}
                className="creat-modal EditPersonModal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="350px"
                onOk={this.onOk}
                onCancel={this.onCancel}
            >
                <div style={{padding:'0 20px'}}>
                    <div style={{marginBottom:'10px'}}>请选择需要下载的模板:</div>
                    <Checkbox checked={templateType1} onChange={(e) => this.handleTemplate(e,'templateType1')} style={{marginBottom:'10px'}}>预收款退款导入模板</Checkbox>
                    <br />
                    <Checkbox checked={templateType2} onChange={(e) => this.handleTemplate(e,'templateType2')}>外币收款汇率差异导入&重复收款导入模板</Checkbox>
                </div>
            </Modal>
        )
    }

    getUploadModal = () =>{
        const {visibleUpload ,uploadMes} = this.state;
        return (
            <Modal 
                visible={visibleUpload}
                width={350}
                footer={null}
                >
                <div>
                    <div style={{fontSize:'14px',fontWeight:'700',margin:'10px 0',lineHeight:'24px',height:'24px'}}><Icon type="exclamation-circle" style={{color:'#ffbf00',fontSize:'24px',marginRight:'10px',verticalAlign: 'bottom'}}/>{uploadMes.title}</div>
                    <div style={{padding:'0 35px'}}>
                    <p>导入成功{uploadMes.successNum}条</p>
                    <p>导入失败{uploadMes.failNum}条</p>
                    </div>
                    <div style={{textAlign:'right',marginTop:'20px'}}>
                        <Button size='large' style={{margin:'0 5px',fontSize:'12px'}} 
                        onClick={()=>{this.setState({visibleUpload:false})}}>关闭</Button>
                        {
                            uploadMes.failNum == 0?
                            <Button type="primary" size='large' style={{margin:'0 5px',fontSize:'12px',backgroundColor:'#169bd5',fontSize:'12px',borderColor:'#169bd5'}} onClick={()=>{this.setState({visibleUpload:false})}}>确定</Button>:
                            <Button type="primary" size='large' style={{margin:'0 5px',backgroundColor:'#169bd5',fontSize:'12px',borderColor:'#169bd5'}} onClick={()=>{
                                this.downErrorReport({type:uploadMes.title == '本次导入的“外币收款汇率差异”数据：'?'FOREIGN_CURRENCY_IMPORT':null})
                            }}>下载错误报告</Button>
                        }
                    </div>
                </div>
            </Modal>
        )
    }

    onOk = () =>{
        const {templateType1 ,templateType2} = this.state;
        if(templateType1){
            this.downTemplate();
        }
        if(templateType2){
            this.downTemplate({type:'FOREIGN_CURRENCY_IMPORT'});
        }
        this.onCancel()
    }

    onCancel = () =>{
        this.setState({
            visible:false,
            templateType1:false,
            templateType2:false,
        })
    }
    handleTemplate = (e ,templateType) =>{
        const value = e.target.checked;
        const templateTypeObj = {};
        templateTypeObj[templateType] = value;
        this.setState(templateTypeObj)
    }

    onUplodChange = (file,fileList)=> {
        if (file.status == "done") {
            if (file.response.error) {  
                message.error(file.response.error);
                file.status = 'removed';
            } else {
                const {uploadMes} = this.state;
                uploadMes.title=file.response.title;
                uploadMes.errorNum=file.response.errorNum;
                uploadMes.successNum=file.response.successNum;
                uploadMes.failNum=file.response.failNum;
                this.setState({uploadMes,visibleUpload:true})
            }
        }
    }
    
    //下载错误报告
    downErrorReport = (params)=>{
        ExportUtil.export(params, null, API_URL.contract.getAdvanceImportFailList);
        message.success('正在下载中!')
    }
    //下载模板
    downTemplate = (params) => {
        ExportUtil.export(params, null, API_URL.contract.getAdvancesReceivedReimburseTemp);
        message.success('正在下载中!')
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { invId ,curRole } = sessionStorage;
        const { data, loading, pagination, searchParams, sortParams, businessList, contractTypeList, belongingToUnit } = this.state;
        const Buttons = [<Button key="export" type="primary" onClick={this.export}>导出</Button>];
        if(curRole == 'FIN' && !invId){
            Buttons.push(
                <Button key="downloadTemplate" type="primary" onClick={this.downloadTemplate}>下载模板</Button>,
                <UploadFile
                    uploadUrl={API_URL.contract.importAdvancesReceivedReimburse}
                    showUploadList={false}
                    onChange={this.onUplodChange}
                >
                    <Button type="primary" style={{backgroundColor:'#ffcc00',border:'0'}}>导入数据</Button>
                </UploadFile>
            )
        }
        return (
            <div className="content">
                {
                    invId == 0 ?
                        <SideNav selectKey='returnedMoney' />
                    :
                        <ProjectSideNav selectKey='returnedMoney' />
                }
                <div className="main">
                    <Filter
                        expandHeight={190}
                        search={this.search}
                        params={searchParams}
                        businessList={businessList}
                        belongingToUnit={belongingToUnit}
                        contractTypeList={contractTypeList}
                        onChange={this.handleFilterChange}
                        buttons={Buttons}
                        />
                    <TableC
                        data={data}
                        scrollY={500}
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        // rowKey="contractBackRecordId"
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                    {this.getDownloadTemplate()}
                    {this.getUploadModal()}
                    <Config ref={el => this.configRef = el} loadData={this.loadData} />
                    <Operation ref={el => this.operationRef = el}  />
                    <Update ref={el => this.updateRef = el} loadData={this.loadData} />
                    <ConfigColumn
                        ref={el => this.configColumnRef = el}
                        getHeader={this.getHeader}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturnedMoney);


// WEBPACK FOOTER //
// ./src/components/contractManagement/returnedMoney/index.js